import { render, staticRenderFns } from "./resultPoint.vue?vue&type=template&id=ced301e6&scoped=true"
import script from "./resultPoint.vue?vue&type=script&lang=js"
export * from "./resultPoint.vue?vue&type=script&lang=js"
import style0 from "./resultPoint.vue?vue&type=style&index=0&id=ced301e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced301e6",
  null
  
)

export default component.exports